var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sc-form", {
        ref: "contactForm",
        attrs: { autocomplete: "off" },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c(
                  "div",
                  { staticClass: "mainContent" },
                  [
                    !_vm.isEdit
                      ? _c("div", { staticClass: "mainContent__paragraphs" }, [
                          _c("p", [
                            _vm._v(
                              "\n            Nessa etapa, você precisará configurar os REIDs (remetente IDs)\n            que são obtidos com a Total Express. Para cada centro de\n            distribuição e tipo de serviço contratado com a Total Express,\n            preencha o REID correspondente.\n          "
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mainContent__reidTable" },
                      _vm._l(_vm.remetente_id_mapping, function(row, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "mainContent__reidRow" },
                          [
                            _c(
                              "sc-field",
                              {
                                attrs: {
                                  label: "Centro de Distribuição",
                                  type: _vm.getFieldType(
                                    row,
                                    row.cnpj_warehouse
                                  ),
                                  message: _vm.getMessage(
                                    row,
                                    row.cnpj_warehouse
                                  )
                                }
                              },
                              [
                                _c(
                                  "sc-select",
                                  {
                                    staticClass: "span__select",
                                    on: {
                                      input: function($event) {
                                        _vm.refreshRow(row)
                                      }
                                    },
                                    model: {
                                      value: row.cnpj_warehouse,
                                      callback: function($$v) {
                                        _vm.$set(row, "cnpj_warehouse", $$v)
                                      },
                                      expression: "row.cnpj_warehouse"
                                    }
                                  },
                                  _vm._l(_vm.warehouses, function(
                                    warehouse,
                                    index
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: {
                                          value: warehouse.federal_tax_payer_id
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(warehouse.name) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-field",
                              {
                                attrs: {
                                  label: "CNPJ do centro de distribuição"
                                }
                              },
                              [
                                _c("sc-input", {
                                  attrs: {
                                    disabled: true,
                                    value: row.cnpj_warehouse
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-field",
                              {
                                attrs: {
                                  label: "Tipo de Serviço",
                                  type: _vm.getFieldType(row, row.service_type),
                                  message: _vm.getMessage(row, row.service_type)
                                }
                              },
                              [
                                _c(
                                  "sc-select",
                                  {
                                    staticClass: "span__select",
                                    on: {
                                      input: function($event) {
                                        _vm.refreshRow(row)
                                      }
                                    },
                                    model: {
                                      value: row.service_type,
                                      callback: function($$v) {
                                        _vm.$set(row, "service_type", $$v)
                                      },
                                      expression: "row.service_type"
                                    }
                                  },
                                  _vm._l(_vm.servicesTypes, function(
                                    serviceType,
                                    index
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: serviceType.value }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(serviceType.label) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-field",
                              {
                                attrs: {
                                  label: "remetente ID",
                                  type:
                                    row.remetente_id == "" ? "is-danger" : "",
                                  message:
                                    row.remetente_id == ""
                                      ? "O campo é obrigatório"
                                      : ""
                                }
                              },
                              [
                                _c("sc-input", {
                                  on: {
                                    input: function($event) {
                                      _vm.refreshForm()
                                    }
                                  },
                                  model: {
                                    value: row.remetente_id,
                                    callback: function($$v) {
                                      _vm.$set(row, "remetente_id", $$v)
                                    },
                                    expression: "row.remetente_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-button",
                              {
                                staticClass: "removeButton",
                                attrs: {
                                  disabled: _vm.remetente_id_mapping.length == 1
                                },
                                on: {
                                  click: function($event) {
                                    _vm.removeRow(index)
                                  }
                                }
                              },
                              [_vm._v("X")]
                            )
                          ],
                          1
                        )
                      })
                    ),
                    _vm._v(" "),
                    _c("sc-button", { on: { click: _vm.addRow } }, [
                      _vm._v("Adicionar")
                    ])
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _vm.isEdit
                  ? _c(
                      "div",
                      { staticClass: "editButtons" },
                      [
                        _c("sc-button", {
                          staticClass: "startIntegration",
                          attrs: { text: "Cancelar", theme: "primary" }
                        }),
                        _vm._v(" "),
                        _c("sc-button", {
                          staticClass: "startIntegration",
                          attrs: { text: "Salvar", theme: "primary" }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("sc-button", {
                          attrs: {
                            text: "Voltar",
                            theme: "default",
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              _vm.backStep()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("sc-button", {
                          attrs: {
                            text: "Próximo",
                            theme: "primary",
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              _vm.navigateNext()
                            }
                          }
                        })
                      ],
                      1
                    )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eb19091", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb19091","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-reids/ScReids.vue
// module id = null
// module chunks = 